module.exports = __webpack_public_path__ + "img/nash_cert.c02c48df.png";